// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"d57bde76","447":"2de1f4c6","748":"be74b185","942":"f50506f6"}[chunkId] + ".chunk.css";
};